import sanga3 from "../assets/gedo (8).jpg"
import gido from "../assets/gido (2).jpg"
import gido2 from "../assets/gido (6).jpg"
import gido3 from "../assets/gido (5).jpg"
import gido4 from "../assets/gido (4).jpg"
import gido5 from "../assets/gido (3).jpg"
import gido6 from "../assets/gido (7).jpg"
import gido7 from "../assets/gido (8).jpg"
import about from "../assets/gedo (4).jpg"
import vision from "../assets/gedo (5).jpg"
import mision from "../assets/gedo (2).jpg"
import team1 from "../assets/gedo (9).jpg"
import team2 from "../assets/gedo (10).jpg"
import team3 from "../assets/gedo (11).jpg"
import asina from "../assets/asina.jpg"
import shipa from "../assets/shipa.jpg"
import magzob from "../assets/kids (2).jpg"
import Aos from 'aos';
import 'aos/dist/aos.css'
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
export default function AboutUs() {

  const { i18n } = useTranslation();
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };
  const { t } = useTranslation();


  useEffect(() => {
    Aos.init({ duration: 2000 });
  });

  const team = [
    {
      name: "Madani Abdalla Madani",
      email: "General Manager , Instructor Driver , IMCA Air Diver 50 meters",
      phone: "+249 129102102",
      image: team1,
    },
    {
      name: "Majzoub Badr Al-Deen kamel",
      email: "CEO , Commercila diver (IDAS)",
      phone: "+249 900008229",
      image: magzob,
    },
    {
      name: "Ammar Ibrahim Al-Nasri",
      email: "Dive Master (padi)",
      phone: "+249 900008226 ",
      image: shipa,
    },
  ];
  return (

    <div className="">

      <div className='relative w-full justify-center items-center flex flex-col'>
        <img src={sanga3} data-aos="fade-up" className="justify-center items-center w-full md:w-[75%] 
     object-cover  border-blue-300 flex-shrink-0"/>
        <div className="absolute inset-0 flex flex-col justify-center items-center">
          <div data-aos="fade-right" className='text-white bg-blue-300 w-[30%]  md:w-[20%] md:h-[30%] m-6  
    rounded absolute justify-center items-center top-30 p-3 pt-4 flex flex-col'>
            <p className=" justify-center items-center text-center text-sm md:text-xl  p-2">
              {t("siteName")} </p>
            <p className="  justify-center items-center text-center text-sm md:text-xl  p-2">
              {t("main2")}  </p>
            <p className="tjustify-center items-center text-center text-sm md:text-xl  p-2">
              {t("since")} </p>
          </div>
        </div>
      </div>


      <div className="mt-5 bg-blue-100 w-full ">

        <div className="h-full w-full flex flex-col md:flex-row-reverse items-center
 gap-4 p-4  rounded shadow">

          <div className='relative w-full md:w-[50%] h-[90%] '>
            <img src={about} data-aos="fade-left" className=" w-full h-full object-cover rounded
      border-blue-300 flex-shrink-0"/>
          </div>
          <div data-aos="fade-right" dir={i18n.language === "ar" ? "rtl" : "ltr"} className="text-left  ml-4  flex flex-col 
 justify-center flex-1 h-[90%] overflow-auto px-6">

            <h2 className="text-2xl md:text-4xl font-bold mb-2 text-gray-700">{t("siteName")}</h2>
            <p className="text-gray-700 ">
              {t("team")}
            </p>
          </div>

        </div>
      </div>

      <div className=" bg-blue-50 w-full ">
        <div className="h-full w-full flex flex-col md:flex-row-reverse items-center
 gap-4 p-4  rounded shadow">
          <div className='relative w-full md:w-[50%] h-[90%] '>
            <img src={vision} data-aos="fade-right" className=" w-full h-full object-cover rounded
      border-blue-300 flex-shrink-0"/>
          </div>
          <div data-aos="fade-left" dir={i18n.language === "ar" ? "rtl" : "ltr"} className="text-left  ml-4  flex flex-col 
 justify-center flex-1 h-[90%] overflow-auto px-6">
            <h2 className=" text-2xl md:text-4xl font-bold mb-2 text-gray-700">{t("vision2")}</h2>
            <p className="text-gray-700 ">
              {t("vision")}
            </p>
          </div>

        </div>
      </div>

      <div className=" bg-blue-100 w-full ">

        <div className="h-full w-full flex flex-col md:flex-row-reverse items-center
 gap-4 p-4  rounded shadow">

          <div className='relative w-full md:w-[50%] h-[90%] '>
            <img src={mision} data-aos="fade-left" className=" w-full h-full object-cover rounded
      border-blue-300 flex-shrink-0"/>
          </div>
          <div data-aos="fade-right" dir={i18n.language === "ar" ? "rtl" : "ltr"} className="text-left  ml-4  flex flex-col 
 justify-center flex-1 h-[90%] overflow-auto px-6">

            <h2 className="text-2xl md:text-4xl font-bold mb-2 text-gray-700">{t("mission")}</h2>
            <p className="text-gray-700 ">
              {t("mision")}
            </p>
          </div>

        </div>

      </div>

      <div className="bg-gray-100 py-10 px-4  my-10">
        <h2 className="text-2xl md:text-3xl font-bold text-center mb-8">{t("teame")}</h2>

        <div data-aos="fade-up" className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {team.map((member, index) => (
            <div key={index} className="relative group rounded-lg overflow-hidden shadow-lg">
              <img
                src={member.image}
                alt={member.name}
                className="w-full h-full object-cover" />
              <div dir={i18n.language === "ar" ? "rtl" : "ltr"} className="absolute inset-0 bg-blue-400 bg-opacity-70 flex flex-col 
            justify-center items-center text-white opacity-0 group-hover:opacity-100
             transition-opacity duration-500">
                <h3 className="text-xl font-bold mb-2">{member.name}</h3>
                <p className="text-sm">{member.email}</p>
                <p className="text-sm">{member.phone}</p>
              </div>
            </div>
          ))}
        </div>
      </div>


      {/* ///////////////////////////////////////////////////////////////////////////////////// */}


      <div className="flex justify-center"><h1 data-aos="fade-up" className="font-serif text-gray-600 
 text-2xl md:text-4xl font-bold m-6">{t("experience")}</h1></div>

      <div className=" w-full flex flex-col md:flex-row-reverse items-center gap-4 p-4 bg-white rounded shadow">

        <div className='relative w-[500px] '>
          <img src={asina} data-aos="fade-left"
            className=" h-[200px] w-full md:w-[500px] md:h-[400px] object-cover rounded
      border-blue-300 flex-shrink-0"/>
          <div className="hidden md:block absolute inset-0 flex  flex-col justify-center ">
            <div className='bg-blue-300 w-20 h-20 m-6  rounded absolute justify-center items-center'>
              <h2 className="text-white  text-xl md:text-xl font-bold p-2">15 years</h2>
            </div>
          </div>
        </div>

        <div data-aos="fade-right" dir={i18n.language === "ar" ? "rtl" : "ltr"} className="text-right  ml-4 
         flex flex-col justify-center flex-1 overflow-auto px-6">
          <h2 className=" text-2xl md:text-4xl font-bold mb-2 text-gray-700">{t("asina")}</h2>
          <div className="text-gray-700 ">

            <p className="text-gray-700 font-bold">
              {t("asina2")}
            </p>
          </div>
        </div>
        <div className="w-5 h-[300px] hidden md:block ">
          <div className="w-5 h-5 rounded-full bg-blue-300"></div>
          <div className="w-1 h-10 bg-blue-300 m-2"></div>
          <div className="w-5 h-5 rounded-full bg-blue-300"></div>
          <div className="w-1 h-10 bg-blue-300 m-2"></div>
          <div className="w-5 h-5 rounded-full bg-blue-300"></div>
          <div className="w-1 h-10 bg-blue-300 m-2"></div>
          <div className="w-5 h-5 rounded-full bg-blue-300"></div>
          <div className="w-1 h-10 bg-blue-300 m-2"></div>
        </div>

      </div>

      <div className=" w-full flex flex-col md:flex-row-reverse items-center gap-4 p-4 bg-white rounded shadow">

        <div className='relative w-[500px] '>
          <img src={gido} data-aos="fade-left" className=" h-[200px] w-full md:w-[500px] md:h-[400px] object-cover rounded
      border-blue-300 flex-shrink-0"/>
          <div className="hidden md:block absolute inset-0 flex  flex-col justify-center ">
            <div className='bg-blue-300 w-20 h-20 m-6  rounded absolute justify-center items-center'>
              <h2 className="text-white  text-xl md:text-xl font-bold p-2">15 years</h2>
            </div>
          </div>
        </div>

        <div data-aos="fade-right" dir={i18n.language === "ar" ? "rtl" : "ltr"} className="text-right  ml-4 
         flex flex-col justify-center flex-1 overflow-auto px-6">
          <h2 className="text-2xl md:text-4xl font-bold mb-2 text-gray-700">{t("gido_year")}</h2>
          <div className="text-gray-700 ">
            <p className="text-gray-700 font-bold">
              {t("gido_desc")}
            </p>
          </div>
        </div>
        <div className="w-5 h-[300px] hidden md:block ">
          <div className="w-5 h-5 rounded-full bg-blue-300"></div>
          <div className="w-1 h-10 bg-blue-300 m-2"></div>
          <div className="w-5 h-5 rounded-full bg-blue-300"></div>
          <div className="w-1 h-10 bg-blue-300 m-2"></div>
          <div className="w-5 h-5 rounded-full bg-blue-300"></div>
          <div className="w-1 h-10 bg-blue-300 m-2"></div>
          <div className="w-5 h-5 rounded-full bg-blue-300"></div>
          <div className="w-1 h-10 bg-blue-300 m-2"></div>
        </div>

      </div>

      <div className=" w-full flex flex-col md:flex-row-reverse items-center
       gap-4 p-4 bg-white rounded shadow">

        <div className='relative w-[500px]  '>
          <img src={gido3} data-aos="fade-right" className=" h-[200px] w-full md:w-[500px] md:h-[400px] object-cover rounded
      border-blue-300 flex-shrink-0"/>
          <div className=" hidden md:block absolute inset-0 flex  flex-col justify-center ">
            <div className='bg-blue-300 w-20 h-20 m-6  rounded absolute justify-center items-left'>
              <h2 className="text-white  text-xl md:text-xl font-bold p-2">15 years</h2>
            </div>
          </div>

        </div>

        <div data-aos="fade-left" dir={i18n.language === "ar" ? "rtl" : "ltr"} className="text-right ml-4  flex flex-col justify-center flex-1  overflow-auto px-6">
          <h2 className="text-2xl md:text-4xl justify-center font-bold mb-2 text-gray-700">{t("gido3_title")}</h2>
          <p className="text-gray-700 font-bold">
            {t("africa")}
          </p>

        </div>
        <div className="w-5 h-[300px]  hidden md:block ">
          <div className="w-5 h-5 rounded-full bg-blue-300"></div>
          <div className="w-1 h-10 bg-blue-300 m-2"></div>
          <div className="w-5 h-5 rounded-full bg-blue-300"></div>
          <div className="w-1 h-10 bg-blue-300 m-2"></div>
          <div className="w-5 h-5 rounded-full bg-blue-300"></div>
          <div className="w-1 h-10 bg-blue-300 m-2"></div>
          <div className="w-5 h-5 rounded-full bg-blue-300"></div>
          <div className="w-1 h-10 bg-blue-300 m-2"></div>
        </div>


      </div>

      <div className=" w-full flex flex-col md:flex-row-reverse items-center gap-4 p-4 bg-white rounded shadow">
        <div className='relative w-[500px]  '>
          <img src={gido4} data-aos="fade-left" className=" h-[200px] w-full md:w-[500px] md:h-[400px] object-cover rounded
      border-blue-300 flex-shrink-0"/>
          <div className="hidden md:block absolute inset-0 flex  flex-col justify-center ">
            <div className='bg-blue-300 w-20 h-20 m-6  rounded absolute justify-center items-center'>
              <h2 className="text-white  text-xl md:text-xl font-bold p-2">15 years</h2>
            </div>
          </div>

        </div>

        <div data-aos="fade-left" dir={i18n.language === "ar" ? "rtl" : "ltr"} className="text-right ml-4  flex flex-col justify-center flex-1  overflow-auto px-6">
          <h2 className="text-2xl md:text-4xl justify-center font-bold mb-2 text-gray-700">{t("sunck")}</h2>
          <p className="text-gray-700 font-bold">{t("sunck2")}</p>

        </div>

        <div className="w-5 h-[300px]  hidden md:block  ">
          <div className="w-5 h-5 rounded-full bg-blue-300"></div>
          <div className="w-1 h-10 bg-blue-300 m-2"></div>
          <div className="w-5 h-5 rounded-full bg-blue-300"></div>
          <div className="w-1 h-10 bg-blue-300 m-2"></div>
          <div className="w-5 h-5 rounded-full bg-blue-300"></div>
          <div className="w-1 h-10 bg-blue-300 m-2"></div>
          <div className="w-5 h-5 rounded-full bg-blue-300"></div>
          <div className="w-1 h-10 bg-blue-300 m-2"></div>
        </div>

      </div>

      <div className=" w-full flex flex-col md:flex-row-reverse items-center gap-4 p-4 bg-white rounded shadow">

        <div className='relative w-[500px]  '>
          <img src={gido5} data-aos="fade-right" className=" h-[200px] w-full md:w-[500px] md:h-[400px]  object-cover rounded
      border-blue-300 flex-shrink-0"/>
          <div className="hidden md:block absolute inset-0 flex  flex-col justify-center ">
            <div className='bg-blue-300 w-20 h-20 m-6  rounded absolute justify-center items-left'>
              <h2 className="text-white  text-xl md:text-xl font-bold p-2">15 years</h2>
            </div>
          </div>
        </div>
        <div data-aos="fade-left" dir={i18n.language === "ar" ? "rtl" : "ltr"} className="text-right ml-4  flex flex-col justify-center flex-1  overflow-auto px-6">
          <h2 className=" text-2xl md:text-4xl justify-center font-bold mb-2 text-gray-700">{t("ship")}</h2>
          <p className="text-gray-700 font-bold">
            {t("ship2")}
          </p>

        </div>

        <div className="w-5 h-[300px] hidden md:block  ">
          <div className="w-5 h-5 rounded-full bg-blue-300"></div>
          <div className="w-1 h-10 bg-blue-300 m-2"></div>
          <div className="w-5 h-5 rounded-full bg-blue-300"></div>
          <div className="w-1 h-10 bg-blue-300 m-2"></div>
          <div className="w-5 h-5 rounded-full bg-blue-300"></div>
          <div className="w-1 h-10 bg-blue-300 m-2"></div>
          <div className="w-5 h-5 rounded-full bg-blue-300"></div>
          <div className="w-1 h-10 bg-blue-300 m-2"></div>
        </div>
      </div>


      <div className=" w-full flex flex-col md:flex-row-reverse items-center gap-4 p-4 bg-white rounded shadow">
        <div className='relative w-[500px]  '>
          <img src={gido7} data-aos="fade-left" className=" h-[200px] w-full md:w-[500px] md:h-[400px] object-cover rounded
      border-blue-300 flex-shrink-0"/>
          <div className="hidden md:block absolute inset-0 flex  flex-col justify-center ">
            <div className='bg-blue-300 w-20 h-20 m-6  rounded absolute justify-center items-center'>
              <h2 className="text-white  text-xl md:text-xl font-bold p-2">15 years</h2>
            </div>
          </div>

        </div>
        <div data-aos="fade-left" dir={i18n.language === "ar" ? "rtl" : "ltr"} className="text-right ml-4  flex flex-col justify-center flex-1  overflow-auto px-6">
          <h2 className="text-2xl md:text-4xl justify-center font-bold mb-2 text-gray-700">{t("ut")}</h2>
          <p className="text-gray-700 font-bold">{t("ut2")}
          </p>

        </div>

        <div className="w-5 h-[300px] hidden md:block  ">
          <div className="w-5 h-5 rounded-full bg-blue-300"></div>
          <div className="w-1 h-10 bg-blue-300 m-2"></div>
          <div className="w-5 h-5 rounded-full bg-blue-300"></div>
          <div className="w-1 h-10 bg-blue-300 m-2"></div>
          <div className="w-5 h-5 rounded-full bg-blue-300"></div>
          <div className="w-1 h-10 bg-blue-300 m-2"></div>
          <div className="w-5 h-5 rounded-full bg-blue-300"></div>
          <div className="w-1 h-10 bg-blue-300 m-2"></div>
        </div>

      </div>


      <div className=" w-full flex flex-col md:flex-row-reverse items-center gap-4 p-4 bg-white rounded shadow">


        <div className='relative w-[500px]  '>
          <img src={gido6} data-aos="fade-right" className=" h-[200px] w-full md:w-[500px] md:h-[400px]  object-cover rounded
      border-blue-300 flex-shrink-0"/>
          <div className="hidden md:block absolute inset-0 flex  flex-col justify-center ">
            <div className='bg-blue-300 w-20 h-20 m-6  rounded absolute justify-center items-left'>
              <h2 className="text-white  text-xl md:text-xl font-bold p-2">15 years</h2>
            </div>
          </div>
        </div>
        <div data-aos="fade-left" dir={i18n.language === "ar" ? "rtl" : "ltr"} className="text-right ml-4  flex flex-col justify-center flex-1  overflow-auto px-6">
          <h2 className=" text-2xl md:text-4xl justify-center font-bold mb-2 text-gray-700">{t("shape")}</h2>
          <p className="text-gray-700 font-bold">{t("shape2")}
          </p>

        </div>
        <div className="w-5 h-[300px]  hidden md:block ">
          <div className="w-5 h-5 rounded-full bg-blue-300"></div>
          <div className="w-1 h-10 bg-blue-300 m-2"></div>
          <div className="w-5 h-5 rounded-full bg-blue-300"></div>
          <div className="w-1 h-10 bg-blue-300 m-2"></div>
          <div className="w-5 h-5 rounded-full bg-blue-300"></div>
          <div className="w-1 h-10 bg-blue-300 m-2"></div>
          <div className="w-5 h-5 rounded-full bg-blue-300"></div>
          <div className="w-1 h-10 bg-blue-300 m-2"></div>
        </div>

      </div>

      <div className=" w-full flex flex-col md:flex-row-reverse items-center gap-4 p-4 bg-white rounded shadow">
        <div className='relative w-[500px]  '>
          <img src={gido2} data-aos="fade-left" className=" h-[200px] w-full md:w-[500px] md:h-[400px]  object-cover rounded
      border-blue-300 flex-shrink-0"/>
          <div className="hidden md:block absolute inset-0 flex  flex-col justify-center ">
            <div className='bg-blue-300 w-20 h-20 m-6  rounded absolute justify-center items-center'>
              <h2 className="text-white  text-xl md:text-xl font-bold p-2">15 years</h2>
            </div>
          </div>

        </div>
        <div data-aos="fade-left" dir={i18n.language === "ar" ? "rtl" : "ltr"} className="text-right ml-4  flex flex-col justify-center flex-1  overflow-auto px-6">
          <h2 className="text-2xl md:text-4xl justify-center font-bold mb-2 text-gray-700">{t("goos")}</h2>
          <p className="text-gray-700 font-bold">{t("goos2")}

          </p>

        </div>

        <div className="w-5 h-[300px] hidden md:block  ">
          <div className="w-5 h-5 rounded-full bg-blue-300"></div>
          <div className="w-1 h-10 bg-blue-300 m-2"></div>
          <div className="w-5 h-5 rounded-full bg-blue-300"></div>
          <div className="w-1 h-10 bg-blue-300 m-2"></div>
          <div className="w-5 h-5 rounded-full bg-blue-300"></div>
          <div className="w-1 h-10 bg-blue-300 m-2"></div>
          <div className="w-5 h-5 rounded-full bg-blue-300"></div>
          <div className="w-1 h-10 bg-blue-300 m-2"></div>
        </div>

      </div>

    </div>

  )
}